export enum IFavoriteApi {
    add = '/api/estate-favorite/add',
    remove = '/api/estate-favorite/remove',
    clear = '/api/estate-favorite/clear',
    bulkRemove = '/api/estate-favorite/bulkRemove'
}
